"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectFormModel = exports.IkeObjectForm = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectForm = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectForm, _super);
    function IkeObjectForm() {
        var _this = _super.call(this) || this;
        _this.className = 'Form';
        _this.actionName = 'form';
        _this.cacheKeys['revision'] = true;
        // Required for mapsight-web form designer
        _this.cacheKeys['version'] = true;
        return _this;
    }
    return IkeObjectForm;
}(base_1.IkeRestObject));
exports.IkeObjectForm = IkeObjectForm;
exports.IkeObjectFormModel = {
    className: 'FormModel',
    actionName: 'form.model',
    canCache: function (key) {
        return key === 'revision' || key === 'version';
    }
};
//# sourceMappingURL=form.object.js.map